module.exports = __webpack_public_path__ + "static/media/andre.60ee8787.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/labs/andre.png
// module id = 118
// module chunks = 0